module.exports = __webpack_public_path__ + "static/img/chat-pass.a1da3c7d.png";